import {NgModule} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {HighlightEndTextComponent} from './highlight-end-text.component';


@NgModule({
  declarations: [HighlightEndTextComponent],
    imports: [
        CommonModule,
        NgOptimizedImage
    ],
  exports: [HighlightEndTextComponent]
})
export class HighlightEndTextModule {
}
